module.exports = {"220403100":"灯塔镇","220403198":"县级直管村级单位（特殊镇）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220403.json
// module id = 636
// module chunks = 0